"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Avatar_1 = __importDefault(require("../Avatar"));
var styles_1 = require("./styles");
// AvatarLockup functional component
var AvatarLockup = function (_a) {
    var name = _a.name, pronouns = _a.pronouns, information = _a.information, _b = _a.align, align = _b === void 0 ? 'left' : _b, // Default alignment is 'left'
    _c = _a.emphasized, // Default alignment is 'left'
    emphasized = _c === void 0 ? true : _c, // Default emphasis is true
    src = _a.src, alt = _a.alt, size = _a.size, _d = _a.lineOfText, lineOfText = _d === void 0 ? false : _d, // Default lineofText is false
    style = _a.style, key = _a.key, dataTestId = _a["data-testid"], ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"], ariaDescribedBy = _a["aria-describedby"];
    return (react_1.default.createElement(react_1.default.Fragment, null, lineOfText ? (react_1.default.createElement(styles_1.LineOfTextContainer, { style: style, key: key, "data-testid": dataTestId, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy },
        name && (react_1.default.createElement(styles_1.UserNameLink, { lineOfText: lineOfText, emphasized: emphasized, href: src, linkVariant: "name", context: "quiet" },
            ' ',
            name,
            ' ')),
        pronouns && (react_1.default.createElement(styles_1.UserPronounsSpan, null,
            " (",
            pronouns.toLowerCase(),
            ")")))) : (react_1.default.createElement(styles_1.AvatarLockupContainer, { style: style, key: key, "data-testid": dataTestId, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy },
        align === 'left' && (src || alt) && (react_1.default.createElement(Avatar_1.default, { tabIndex: 0, src: src, alt: alt, size: size })),
        (name || pronouns || information) && (react_1.default.createElement(styles_1.AvatarInfo, { align: align },
            react_1.default.createElement("div", null,
                name && (react_1.default.createElement(styles_1.UserNameLink, { lineOfText: lineOfText, linkVariant: "name", context: "quiet", emphasized: emphasized, href: src }, name)),
                pronouns && (react_1.default.createElement(styles_1.UserPronounsTypography, null,
                    ' ',
                    "(",
                    pronouns.toLowerCase(),
                    ")"))),
            information && (react_1.default.createElement(styles_1.InformationTypography, { variant: "body2" }, information)))),
        align === 'right' && (src || alt) && (react_1.default.createElement(Avatar_1.default, { tabIndex: 0, src: src, alt: alt, size: size }))))));
};
exports.default = AvatarLockup;
//# sourceMappingURL=index.js.map